import { Component } from '@angular/core';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [MatIcon, MatIconModule, RouterModule, CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent {
  collapsed = false;

  constructor(private router: Router) {}

  toggleSidebar(): void {
    this.collapsed = !this.collapsed;
  }

  navigateTo(route: string): void {
    this.router.navigate([route]);
  }

}
